import React from "react";
import { Link } from "react-router-dom";
import "./WhoWeAre.css";

export default function WhoWeAre() {
  return (
    <section className="who-section">
      <div className="who-container">

        {/* TITLE */}
        <h2 className="who-title">Who We Are</h2>

        {/* DESCRIPTION */}
        <p className="who-desc">
          Densat FM Services Private Limited is a multi-city facility management
          company providing integrated corporate housekeeping, maintenance and
          support services to businesses across India.
        </p>

        {/* BREADCRUMB */}
        <p className="who-breadcrumb">
          <Link to="/" className="who-breadcrumb-link">Home</Link>
          <span className="who-breadcrumb-separator">–</span>
          <Link
            to="/about"
            className="who-breadcrumb-link who-breadcrumb-current"
          >
            About Us
          </Link>
        </p>

      </div>
    </section>
  );
}
